<template>
  <authorization permissionKey="configuration_facilitator_hf" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de Histórico Familiar
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <HFList
                :facilitators="familyHistoryFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import HFList from "@/components/config/hf/list/index.vue";

  export default {
    name: "HFConfig",
    components: {
      HFList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          presence_of: "Presença de",
          pathology: "Patologia",
          relative: "Parente",
        },
      };
    },
    apollo: {
      familyHistoryFacilitators: {
        query: require("@/graphql/family_history_facilitators.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.familyHistoryFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
